import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GruposService } from 'src/app/core/services/groups/grupos.service';
import { MandoInventarioModel } from 'src/app/core/models/groups/groups-model';

@Component({
	selector: 'app-detalle-mando',
	templateUrl: './detalle-mando.component.html',
	styleUrls: ['./detalle-mando.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class DetalleMandoComponent implements OnInit {

	idMando: string = '';
	mando: MandoInventarioModel | null = null;
	loading: boolean = false;

	estadoLabels: { [key: number]: string } = {
		0: 'Libre',
		1: 'Asignado',
		2: 'Perdido',
		3: 'Estropeado'
	};

	estadoColors: { [key: number]: string } = {
		0: '#28a745',
		1: '#3366ff',
		2: '#ff9f43',
		3: '#ff3d71'
	};

	constructor(
		public activeModal: NgbActiveModal,
		private gruposService: GruposService
	) {}

	ngOnInit() {
		this.loadDetalle();
	}

	closeModal() {
		this.activeModal.close();
	}

	loadDetalle() {
		if (!this.idMando) return;
		this.loading = true;
		this.gruposService.getMandoDetalle(this.idMando).subscribe({
			next: (res) => {
				if (res && res.data) {
					this.mando = res.data;
				}
				this.loading = false;
			},
			error: () => {
				this.loading = false;
			}
		});
	}

	getBatteryLevel(battery: number): string {
		if (battery >= 75) return 'high';
		if (battery >= 40) return 'medium';
		if (battery >= 15) return 'low';
		return 'critical';
	}

	formatDate(date: Date | string | null): string {
		if (!date) return '—';
		const d = new Date(date);
		return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });
	}
}
